import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-24c3d67c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "cover-background" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "spin ion-text-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100px"},
    src: _imports_0
  })
], -1))
const _hoisted_5 = {
  key: 1,
  style: {"margin":"0 auto"}
}
const _hoisted_6 = { class: "ion-text-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "ion-margin"
}
const _hoisted_9 = {
  key: 0,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_10 = { class: "ion-text-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "OK", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_LuckyGrid = _resolveComponent("LuckyGrid")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_slides = _resolveComponent("slides")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_comment_user_chip = _resolveComponent("comment-user-chip")!
  const _component_comment_content = _resolveComponent("comment-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        logoOnly: true,
        parentPath: "/products"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_buttons, { slot: "end" }, {
            default: _withCtx(() => [
              ($setup.isMuted)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    slot: "icon-only",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.startBackgroundMusic()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: $setup.volumeHigh }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    slot: "icon-only",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.stopBackgroundMusic()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: $setup.volumeMute }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _createVNode(_component_ion_grid, {
            class: "ion-padding-top",
            fixed: ""
          }, {
            default: _withCtx(() => [
              ($setup.loadingAppPublicData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onGridClick && $setup.onGridClick(...args))),
                      ref: "gridContainer",
                      style: _normalizeStyle([{"margin":"0 auto"}, { 'width': `${$setup.screenWidth}px`, 'height': `${$setup.screenWidth}px`}])
                    }, [
                      _createVNode(_component_LuckyGrid, {
                        ref: "luckyWheelEl",
                        width: `${$setup.screenWidth}px`,
                        height: `${$setup.screenWidth}px`,
                        rows: 5,
                        cols: 5,
                        prizes: $setup.getPrizes(),
                        blocks: $setup.blocks,
                        buttons: $setup.wheelBtns,
                        defaultStyle: { background: '#b8c5f2' },
                        defaultConfig: { speed: 10, accelerationTime: 3500, decelerationTime: 6000 },
                        onStart: _cache[2] || (_cache[2] = ($event: any) => ($setup.refreshPrizeProducts(true))),
                        onEnd: $setup.endCallback
                      }, null, 8, ["width", "height", "prizes", "blocks", "buttons", "onEnd"])
                    ], 4),
                    _createElementVNode("div", _hoisted_6, [
                      ($setup.getAvailablePrizes().length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                            ($setup.countdownPrizeId)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  size: "large",
                                  color: "success",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.startLuckyDraw($setup.countdownPrizeId))),
                                  disabled: $setup.isPlayingLuckyWheel
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 立即轉盤 "),
                                    _createVNode(_component_ion_icon, {
                                      slot: "end",
                                      icon: $setup.play
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 1,
                                  size: "large",
                                  color: "primary",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.startGame()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.wonPrizes.length > 0 ? '再抽一次' : '開始遊戲') + " ", 1),
                                    _createVNode(_component_ion_icon, {
                                      slot: "end",
                                      icon: $setup.arrowForward
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                          ]))
                        : (!$setup.refreshingPrizeProducts)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_8, " 所有獎品已售出，感謝您的參與！ "))
                          : _createCommentVNode("", true)
                    ]),
                    (!$setup.product.fetchedDetails)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_ion_spinner)
                        ]))
                      : (_openBlock(), _createBlock(_component_ion_card, {
                          key: 1,
                          style: {"border-radius":"22px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.getLocalizedStr($setup.product, 'title', 'titleEn')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_card_title, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, " HK$" + _toDisplayString(Number($setup.latestGamePrice).toLocaleString()), 1),
                                    _createTextVNode(" / 1 ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_slides, { prizeProducts: $setup.prizeProducts }, null, 8, ["prizeProducts"]),
                            ($setup.isShowCommentSection() && $setup.product.fetchedDetails)
                              ? (_openBlock(), _createBlock(_component_ion_card, {
                                  key: 0,
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openCommentListModal())),
                                  button: "",
                                  style: {"margin-top":"10px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      lines: "full",
                                      button: "",
                                      detail: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "start",
                                          icon: $setup.chatbubbleEllipsesOutline
                                        }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("h2", null, [
                                              _createElementVNode("b", null, _toDisplayString($setup.t('liveChat')), 1)
                                            ])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_chip, {
                                          class: "no-border",
                                          color: "success"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: $setup.person }, null, 8, ["icon"]),
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("b", null, _toDisplayString($setup.onlineViewerCount), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.product.comments.slice().reverse().slice(0, 5), (comment) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        key: comment.id,
                                        lines: "none",
                                        style: {"--padding-start":"8px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_comment_user_chip, { comment: comment }, null, 8, ["comment"]),
                                          _createVNode(_component_ion_label, { style: {"margin":"5px 0"} }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_comment_content, {
                                                comment: comment,
                                                user: $setup.user
                                              }, null, 8, ["comment", "user"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            id: "gift-modal",
            class: "ion-text-center",
            "is-open": $setup.isGiftModalOpened,
            "show-backdrop": true,
            backdropDismiss: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                ($setup.resultGift.prizeProduct?.photoLink)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      style: {"width":"300px"},
                      src: $setup.addResizeUrlParams($setup.resultGift.prizeProduct?.photoLink, 300)
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('congratsYouGot')) + " " + _toDisplayString($setup.resultGift.prizeName || $setup.resultGift.prizeProduct?.title) + "！", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_ion_button, {
                color: "success",
                size: "large",
                shape: "round",
                style: {"--border-radius":"0","margin":"-3px"},
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.onClickGiftModalOK()))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}